import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarBlank } from "@phosphor-icons/react";
import { formatDate } from "@/lib/dates";

// Date picker that always DISPLAYS dd Month yyyy (e.g. "10 October 2026").
// value / onChange use ISO yyyy-mm-dd strings, matching the old <input type=date>.
function isoToDate(v) {
  if (!v) return undefined;
  const [y, m, d] = String(v).slice(0, 10).split("-").map(Number);
  return y && m && d ? new Date(y, m - 1, d) : undefined;
}
function dateToIso(d) {
  if (!d) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function DateField({ value, onChange, min, max, placeholder = "Select date",
  testid, disabled, className, style, align = "start" }) {
  const [open, setOpen] = useState(false);
  const selected = isoToDate(value);
  const base = className || "inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-[13px] font-medium disabled:opacity-50";
  const baseStyle = className ? {} : { borderColor: "#ECECF3", color: value ? "#1B1B2F" : "#8A8C98" };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} disabled={disabled} className={base}
          style={{ ...baseStyle, ...(style || {}) }}>
          <CalendarBlank size={15} weight="bold" className="shrink-0" />
          <span className={!value ? "opacity-60" : ""}>{value ? formatDate(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align={align}>
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected || isoToDate(min)}
          disabled={(d) => {
            const iso = dateToIso(d);
            if (min && iso < String(min).slice(0, 10)) return true;
            if (max && iso > String(max).slice(0, 10)) return true;
            return false;
          }}
          onSelect={(d) => { if (d) { onChange(dateToIso(d)); setOpen(false); } }}
        />
      </PopoverContent>
    </Popover>
  );
}
